import Shreepati from "../Img/Shreepati-Group-Reaching.jpg";
import Runwal from "../Img/Runwal-Logo.jpg";
import WebsiteForm from "./WebsiteForm";
import RunwalShow from "../Img/Runwal-Expo-abudhabi.png";
import { Helmet } from "react-helmet";
export default function AbuDhabi() {
  return (
    <>
      <Helmet>
        <title>ROYAL ROSE HOTEL</title>
        <link rel="canonical" href="https://propexpo.infairs.co.in/abudhabi" />
      </Helmet>
      <section className="lead-genration-page">
        <div className="container-fluid">
          <div className="row mt-lg-5">
            <div className="main-logo d-flex flex-column align-items-center">
              <img src={RunwalShow} alt="Logo" className="img-fluid logo" />
              <p>
              Abu Dhabi
              </p>
            </div>
            {/* <img src={Shreepati} alt="Logo" className="img-fluid logo-2" /> */}
            <div className="col-12 text-center color-theme mb-4 mb-lg-5">
              <h1 className="mb-0 ms-lg-5">
                You're Invited to Visit Mumbai's Finest Luxury Property Expo
              </h1>
            </div>
            <div className="col-lg-8">
              <div className="content">
                {/* <img src={RunwalShow} alt="Logo" className="img-fluid" /> */}
                <h2>ROYAL ROSE HOTEL</h2>
                <h5>
                  ( Nakheel Room - Level 1) <br />
                  1025 Sheikh Zayed The 1st <br />
                  Electra - 7th St - Al Markaziyah District, <br /> Abu Dhabi -
                  United Arab Emirates.
                </h5>
                <h3 className="mb-0 mt-3">8<sup>th</sup>, February 2025.</h3>
                <h3>Sat from 10:30 am to 07:00 pm</h3>
              </div>
            </div>
            <div className="col-md-8 col-lg-4">
              <WebsiteForm />
            </div>
            <div className="col-12">
              <p className="text-white mt-5">
                Artist's Impression | T&C Apply | All Projects are RERA
                Approved.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
